export default __webpack_public_path__ + "2bda3fc85eb53bcf9a566a2eea467099.png";